import { Box, Typography, Grid } from '@mui/material'
import { AutoFixHigh, ArrowForward } from '@mui/icons-material'
import { designSpecs } from '../../theme/designSpecs'
import heroBeforeImage from '../../assets/home/hero_before.png'
import heroAfterImage from '../../assets/home/hero_after.png'

const BeforeAfterSlider = ({ prompt }) => {

  return (
    <Box>
      {/* Before/After Comparison */}
      <Box sx={{ maxWidth: 900, mx: 'auto' }}>
        <Grid container spacing={2}>
          {/* Before Image */}
          <Grid item xs={12} md={6}>
            <Box
              sx={{
                position: 'relative',
                borderRadius: designSpecs.borderRadius.xl,
                overflow: 'hidden',
                boxShadow: designSpecs.shadows.lg,
                border: '2px solid',
                borderColor: 'grey.200',
              }}
            >
              <Box
                component="img"
                src={heroBeforeImage}
                alt="Original product photo of mug before AI transformation"
                draggable={false}
                sx={{
                  width: '100%',
                  height: 'auto',
                  display: 'block',
                }}
              />
              <Box
                sx={{
                  position: 'absolute',
                  top: 12,
                  left: 12,
                  bgcolor: 'rgba(0, 0, 0, 0.7)',
                  backdropFilter: 'blur(8px)',
                  px: 2,
                  py: 1,
                  borderRadius: designSpecs.borderRadius.lg,
                }}
              >
                <Typography
                  sx={{
                    fontSize: designSpecs.typography.sizes.sm,
                    fontWeight: 600,
                    color: 'white',
                  }}
                >
                  Before
                </Typography>
              </Box>
            </Box>
          </Grid>

          {/* Arrow */}
          <Grid
            item
            xs={12}
            md={0}
            sx={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              display: { xs: 'flex', md: 'none' },
            }}
          >
            <Box
              sx={{
                width: 48,
                height: 48,
                borderRadius: '50%',
                bgcolor: 'primary.main',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                boxShadow: designSpecs.shadows.md,
                transform: 'rotate(90deg)',
              }}
            >
              <ArrowForward sx={{ color: 'white', fontSize: 24 }} />
            </Box>
          </Grid>

          {/* After Image */}
          <Grid item xs={12} md={6}>
            <Box
              sx={{
                position: 'relative',
                borderRadius: designSpecs.borderRadius.xl,
                overflow: 'hidden',
                boxShadow: designSpecs.shadows.xl,
                border: '3px solid',
                borderColor: 'primary.main',
              }}
            >
              <Box
                component="img"
                src={heroAfterImage}
                alt="AI-transformed product photo with mug on rustic wooden table in cozy coffee shop setting"
                draggable={false}
                sx={{
                  width: '100%',
                  height: 'auto',
                  display: 'block',
                }}
              />
              <Box
                sx={{
                  position: 'absolute',
                  top: 12,
                  right: 12,
                  bgcolor: 'primary.main',
                  px: 2,
                  py: 1,
                  borderRadius: designSpecs.borderRadius.lg,
                  display: 'flex',
                  alignItems: 'center',
                  gap: 0.75,
                }}
              >
                <AutoFixHigh sx={{ fontSize: designSpecs.iconSizes.sm, color: 'white' }} />
                <Typography
                  sx={{
                    fontSize: designSpecs.typography.sizes.sm,
                    fontWeight: 600,
                    color: 'white',
                  }}
                >
                  After
                </Typography>
              </Box>
            </Box>
          </Grid>
        </Grid>

        {/* Desktop Arrow */}
        <Box
          sx={{
            position: 'absolute',
            top: '50%',
            left: '50%',
            transform: 'translate(-50%, -50%)',
            width: 56,
            height: 56,
            borderRadius: '50%',
            bgcolor: 'primary.main',
            display: { xs: 'none', md: 'flex' },
            alignItems: 'center',
            justifyContent: 'center',
            boxShadow: designSpecs.shadows.xl,
            zIndex: 10,
          }}
        >
          <ArrowForward sx={{ color: 'white', fontSize: 28 }} />
        </Box>
      </Box>

      {/* Prompt Display */}
      <Box
        sx={{
          mt: 3,
          p: 3,
          bgcolor: 'rgba(255, 255, 255, 0.9)',
          backdropFilter: 'blur(8px)',
          borderRadius: designSpecs.borderRadius.xl,
          border: '2px solid',
          borderColor: 'primary.light',
          boxShadow: designSpecs.shadows.md,
        }}
      >
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5, mb: 1.5 }}>
          <AutoFixHigh sx={{ color: 'primary.main', fontSize: designSpecs.iconSizes.md }} />
          <Typography
            sx={{
              fontSize: designSpecs.typography.sizes.sm,
              fontWeight: 600,
              color: 'primary.main',
              textTransform: 'uppercase',
              letterSpacing: '0.05em',
            }}
          >
            AI Prompt
          </Typography>
        </Box>
        <Typography
          sx={{
            fontSize: designSpecs.typography.sizes.base,
            color: 'grey.700',
            fontStyle: 'italic',
            lineHeight: 1.6,
          }}
        >
          "{prompt}"
        </Typography>
      </Box>
    </Box>
  )
}

export default BeforeAfterSlider
